import { createFileRoute, redirect } from '@tanstack/react-router';

import { electricalProjectVersionIdRequired } from '@/config/web-validators';

export const Route = createFileRoute('/(auth)/projects/$projectVersionId/re-inspections/')({
    beforeLoad: ({ params, search }) => {
        throw redirect({
            to: '/projects/$projectVersionId/re-inspections/information',
            params,
            search,
        });
    },
    validateSearch: electricalProjectVersionIdRequired,
});
